import React, {useEffect, useRef, useState} from 'react';
import './App.css';

import {
  useAddress,
  ConnectWallet
} from "@thirdweb-dev/react";
import { ethers } from "ethers";
import axios from "axios";

import { tokenArray } from "./tokens.js";

function App() {
  const address = useAddress();
  const [tokenAmount, setTokenAmount] = useState(0);
  const [optIn, setOptIn] = useState(false);
  const [signature, setSignature] = useState(null)
  const [alreadyOptedIn, setAlreadyOptedIn] = useState(false);
  const [isCustodialOptedIn, setIsCustodialOptedIn] = useState(false);

  let override = 0;

// useEffect(() => {
//   if (address) {
//     axios.get(`https://api.atari.club/getalloptins`)
//     .then((response) => {
//       const allOptIns = response.data;
//       if (address) {
//         const normalizedAddress = address.toLowerCase(); 
//         const matchingOptIn = allOptIns.find((optIn) => optIn.wallet.toLowerCase() === normalizedAddress);
//         if (matchingOptIn && matchingOptIn.overriden) {
//           setIsCustodialOptedIn(true);
//           override = 1;
//         }
//       }
//     })
//     .catch((error) => {
//       console.error('Error checking opt-in status:', error);
//       document.getElementById("connect2").style.display="none"
//       document.getElementById("button-again").style.display="none"
//       document.getElementById("start").style.display="none"
//       document.getElementById("done").classList.remove("col-lg-6")
//       document.getElementById("done").classList.add("col-lg-12")
//       document.getElementById("row").style.minHeight = "100vh";
//       document.getElementById("title").innerHTML = "Please try again later"
//       document.getElementById("description").innerHTML = `Claim opt-in is currently under going maintenance.`
//       document.getElementById("button").style.display="none"
//     });


//     axios.get(`https://api.atari.club/getoptin/${address}`)
//       .then((response) => {
//         if (response.data.optin) {
//           setAlreadyOptedIn(true);
//           document.getElementById("bottom-wizard").style.display="none";
//         }
//         else{
//           document.getElementById("bottom-wizard").style.display=null;
//         }
//       })
//       .catch((error) => {
//         console.error('Error checking opt-in status:', error);
//       });
//   }
// }, [address]);

  const submitOptIn = async () => {
    try {
      const response = await axios.post('https://api.atari.club/optin', {
        wallet: address,
        signature: signature,
        state: true
      });
      document.getElementById("start").style.display="none"
      document.getElementById("done").classList.remove("col-lg-6")
      document.getElementById("done").classList.add("col-lg-12")
      document.getElementById("row").style.minHeight = "100vh";
      document.getElementById("title").innerHTML = "You have opted-in";
      document.getElementById("description").innerHTML = `The claim is scheduled to start on September 1, 2023, run for two weeks, and end on September 15, 2023. Please check our updated FAQs for more information. If you have any questions you can contact our support team by creating a ticket <a href="https://app.customersupportnetworks.com/" target="_blank" style="color:black">here</a>, or reach out to us on <a href="https://discord.gg/atarix" target="_blank" style="color:black">Discord</a> or <a href="https://twitter.com/AtariX" target="_blank" style="color:black">Twiiter.</a>`
      document.getElementById("button-text").innerHTML = "Go Home"
      document.getElementById("button").href = "/"
      document.getElementById("button").removeAttribute("target");
    } catch (error) {
      console.error('Error submitting opt-in:', error);
    }
  }

    const submitOptOut = async () => {
      try {
        const response = await axios.post('https://api.atari.club/optin', {
          wallet: address,
          signature: signature,
          state: false
        });
        document.getElementById("start").style.display="none"
        document.getElementById("done").classList.remove("col-lg-6")
        document.getElementById("done").classList.add("col-lg-12")
        document.getElementById("row").style.minHeight = "100vh";
        document.getElementById("title").innerHTML = "You have opted-out";
        document.getElementById("description").innerHTML = "You have successfully opted-out of the SAND token claim."
        document.getElementById("button-text").innerHTML = "Go Home"
        document.getElementById("button").href = "/"
        document.getElementById("button").removeAttribute("target");
      } catch (error) {
        console.error('Error submitting opt-out:', error);
      }
    }
  
  

  async function runAPI(addr) {
    let wallet = addr.toLowerCase();
    var findTokens = tokenArray[wallet];
      if(findTokens === undefined && override === 0){
        setTokenAmount(0);
        document.getElementById("connect2").style.display=null
        document.getElementById("button-again").style.display=null
        document.getElementById("start").style.display="none"
        document.getElementById("done").classList.remove("col-lg-6")
        document.getElementById("done").classList.add("col-lg-12")
        document.getElementById("row").style.minHeight = "100vh";
        document.getElementById("title").innerHTML = "You are not eligible"
        document.getElementById("description").innerHTML = `If you held ATRI off-chain or in a custodial exchange including Atari Chain, you must complete the <a href="https://qualification.atarioptin.com/" target="_blank" style="color:black">Custodial Qualification</a>.<br><br>If you believe an error has been made please contact our support team by creating a ticket <a href="https://app.customersupportnetworks.com/" target="_blank" style="color:black">here</a>. You may change your wallet using the connect wallet module above.`
        document.getElementById("button").style.display="none"
      }
      else{
      setTokenAmount(findTokens)
      }

    
  }

  // useEffect(() => {
  //   if (address) {
  //     onOptIn()
  //   }
  // }, [address]);

  const previousAddressRef = useRef();
  useEffect(() => {
    previousAddressRef.current = address;
  }, [address]);
  const previousAddress = previousAddressRef.current;

  useEffect(() => {
    if (previousAddress && !address) {
      setSignature(null)
      document.getElementById("loading").style.display="none";
      document.getElementById("bottom-wizard").style.display="none"
    }
  }, [address, previousAddress]);

  var blacklistedAddresses = ["0xa69B6935B0F38506b81224B4612d7Ea49A4B0aCC","0x308f60b55b0ba1faf4948adafaf0ce812f3706c4","0xb4b2226e88de06f20147d8a7afbd2e7457597379","0x101a2ad615defd6b48ab038d6a8ba0e4c9b86b28","0xcd70d4628cbbcfd29e54b30c46ed23c24a513225","0x1ed29f6ba2da1c845f7d990c83ea49624fffdf2c","0x612da4fa7f99cc3b86a30f8df55a928ee5a6afd3","0x1dd9f2382b900c2373c5fc4cc7bf27ee61178f9c","0x4290499de697fb24d9d656557085a5113574c1dd","0x2b6d31b7668cd688848c16f7ca94392eeb21c227","0xa0e63a049c9c86f912e6320b7b76e48f7d691452","0xbe3d17be99ae3e4d3b3ffd863b4607cec10b0660","0x52607cf2ae5a792b87d75b44b86dadd2fd9630fc","0xc72592f4e21d9ec038e173ab7a2efda40d71e3c7","0x4e692f19acb226a7e2e49dad66425c2d7d70f74a","0x9e6d682fcdaeccad231dbcecd79173350307b948","0x953a68ec861bc69fc5abed43b7c691cd8d21ac7e","0x5826f917392db8422d4f6437c6f4145aa44db279","0xe39184c844980afde6c29523d2f2a248d7804824","0x3a78f3ae310d105b2b0ebd0513ef5ec652942076","0xabae0509862dc9ad6fb2c474613d8c882ac6984f","0xb17e6be6fe15d4630601e7556ead77da1bf352ab","0xcd70d4628cbbcfd29e54b30c46ed23c24a513225","0xe584124c6f7c042926060f07c64f7bea0b75d930","0x4e4d80e5b26bfbcada779192427fcaea1bdf7d51","0x50643afdd55241bfac4dcc7c2c4833667b5c926f","0x578a3523062fdffef54c1b7e35d7f7b94a2c86a8","0x6122ddd1da680fcc20cde14482ec0bbe84c56d5e","0x9f3f1181223e72a54f59b98dca58112cbafb95e0","0xdf96cf81c502599efd740e510d17389d6c8acb4f","0xfe4a3a9520f223177e1b0048baa1c506b53f43ba","0xe83669e3edd35497b8faddbeff9946d3c651b22d","0x4f5446bbed79eb3728bfbbaba3be8a25b9e2f807","0x44935417deac5e80ab3d88862c3e51f09429f35a","0xf9f324792d5def8bed8bdacfeee74fe1b98aaa89","0x86013246271e100c5791facd32df82c7fa79bb30","0x0054acbb811971e59f87c0689011528b0367d160","0x4b74384983e93a74bd7939e80fc2834927c48aca","0xa0b3d7d034912d5742c369cccbf2f7375aadbf47","0xc48a0f944a39968b8b114c2fcb94209d6f258ac4","0xdd1466d071641d237b09629a03917cb8226f4b51","0xbf2c751acae0faecd335b529303f55d1f3fd125f","0x3be1bce7cbb04063aa72c5fa16e30e875e3695be","0xb388fb954b1a769ef4960673ee8210f3dd31e63d","0x8b0207eadd2d21517ca575d72b6dd30a35519a06","0xfcabd0d5e73194d3f73b51cc5b7fd8cd5119986f","0x89323f55140f34cd84fdebcfab5fa33233c3213e","0x34f6717d990c7f4b453456bc81dae8dff064f981","0xf834c3ff3a87ce4edc255ba3e2d86e75dda4d3ce","0x92635a6c0b79a75021aa5e67f0ddb1406f52eecf","0x7442569c4401b2895e5e885fa8af1d6dafd773cc","0x75d5171d9976c78e3a1e92c03fc7ce07e60e5f0f","0x626bd35059570f911f8e77c1f1728e91ff701a22","0xb0c31df7c144b7aa4b50809aa1b8400782882c1e","0xac28db3027b24d1cb1c41f19e2a72ceb77989672","0x108bc135bdfd4faa9bb3bd4ef39069d6a0cc4496","0x36dee3285dc15233de6f697dd324244eaecae417","0x5949cffab73fa2121faafebfbfe63d204eed3896","0x094ab6823a46acb5e6eb0c2014cff9e4b67a672d","0x0df86d31e352fbf865367e982c457171168563f8","0x030144a7b670eb8b687523c576787855f79f6a10","0x1af88bcfc2d66ace69d359a640260063d6e9e13f","0x59ee08757af8c6f5d3fcf21e9fb3ccfb172c6ad9","0x8df36dc8af7585c7d4a426e4e8f5492fe10cf461","0xf2c76eed338450c90698b9f9f8de5968b5992958","0xe96142974802ca468da10674ba10b94492f24593","0xe97c313149ccfa67bbcb8fe8fd9eeb92694d173e","0x260bfebdcec7dfc637a5ba27de3caa33479d6272","0x777bba132bd8f49fe4565ef7e9b7ec20b768997c","0x039ac44d39e32fe56e4ca650341a32e83c4b133e","0x7a72b38c173d409026e765ad81dc599da21a31b2","0x079416b13636cb9805b258b5e870ea4348198ca2","0xecb84a0d981d05c04ed62712aa60f3545a8cbea9","0x1276b9a895a1801e2f447fbe4106348162fc23ff","0x3a80c2a51921292e427add0a7aacbf4dde047a19","0xb1c2426f65f9e11a36612cc48d6871bdb1d6d148","0xe9aac3473f915c30d2bccaf16ae5e350ffdc7096","0x000d2102cc1928cbf4877f7b375f6c06c06570a3","0x2a3063161879c6b778235b0e08846fd3563bb079","0x17185cb58501be863c2eb7c97b4a3a14469e0c3f","0xf63cb9cb0ef94200961afc9ed21f44b04b557944","0x6f48e5318d6e9a32bd21448f836c9dfa2173d684","0x1964ad81724c8f358b9b2ea7c5aa5e0f3c203d5b","0x24055c300859aaadc85d3ef742a0a1f2cd512f69","0x5d99c50e25f88c4ea2a6cb265383d2ee2856b505","0xc3ce81edb1d8fddb4fd3c937d753eb58fb424f7f","0xc4230f68a554367d44005bf3bff92197dcef23f7","0x3e4a7b48c03636dc9f5da7c3d54bf8326f02c8e0","0x2ff023bb5bb52b43ba62b36c03ccdd82d90ae7c2","0x5ff0a833b5a6ac02c074f634f3b128f1aa291d95","0x570ab02be9a5cbf2fb8fe128a15384bc2cc65e1d","0x59a5208b32e627891c389ebafc644145224006e8","0xb178d3ccfc96a24872a45bce69d1ef28b6a504ae","0xf06cdea372e2350e374c37f1ee0e1c44b8be6e2e","0x12518eda0347e5e68d802bb94082c996017fb547","0x209c1f21759fde40bb40d3fb810e91b46117e2c6","0x20d99de7e47789679e34f990d1362d7913fa66ca","0x5a1294196008dff5ce68d19e88d9b31e6edad7c5","0x7a61a0ed364e599ae4748d1ebe74bf236dd27b09","0xb63c4974ebdc5302d07510f9593429ec9367719e","0xbcf53d3d4c91825cb52898cb131cf5b9890c2e4d","0xbdb32ae07bed22d78a5e403bd186a7e983e661ec","0xe89db570ee053136a040ae2a0ab3f855ce0477bf","0xf3286e361bd292fedfbf0918cf094ff7de3b5ab3","0x47993ede7c440575cac2b7177be3ca7f89d6128d","0x5e583b6a1686f7bc09a6bba66e852a7c80d36f00","0x6edf968da408a9640b8865826429a977a11c5048","0xb170f1da873df11500c074adc74cb113f50d7990","0xf3f9f45c9bd149a52bf33909db36ddc0a868f021","0xe35f636930f7bebb8b144741e9e1f1d3965f6276","0x099df6e2c1c9cf5dcfaa7af3eb5ac9e2d068b92b","0x0dc55a18c7eb42a3a089753bdcf57a24bdeaea81","0x15b67a41e53c9f135e9bfc1b2d51599539a1dd57","0x1e61948904cac2468bb79bce652e23df3734e4fb","0x43a71c833429f873dca534344fe78a9419ef0830","0x47d2ec1643925270357dec85878dce6e635c6d91","0x4a70f8ecd87697dadaffb7fa8c1d1ff277fef8b3","0x581417f2ae6793c605f0d31a22d049c69ce4626d","0x83cfa4b2a504cffc8943951bf411ac5f6a8fbaf0","0x8e626e485527f8f7c234fb8f221bce10b878a8a7","0xb0d2abcc654c4f1aa97e25254953e49fee0c1035","0xe423d9fa74e9bfbe9b1c649068dbad65d375f12d","0x088e0bdacaccdca4a5f913122a5b152823ebec27","0x6b004ab88a1960f6370cfea140697753776de523","0x70bf8a5d28d8220694c7d5596c579a1238c2f788","0x784717a45ee6832ff5a3aa60ac4a727b2851d233","0xa018d6999dd5a46ab63619851420b783a25abcb0","0xa289320e6087b8a587c1d8993cab96582e92f42f","0xbc58781993b3e78a1b0608f899320825189d3631","0xbf2c141a6cf9d7e33dce75a313518837b5fa2ec3","0xca618f90850b7e0b34e38b353188ef46b969cec5","0xe0a68dbd7884247dd31214f5f730199d76ac8e78","0xf69a324d6adf98c3a4b293d419c80d58671433e8","0xd07f4f3e0ab87804d0ea9cc7f5832e50d54749b3","0xc3f6233c7b1f0c5156a872f32585716dfcb535f6","0xb15e0f6269272d8f84e6b15236d9c8b9c2864251","0xdacd69347de42babfaecd09dc88958378780fb62","0xc9b938e834d8f4e2d21c35b96411007e9d2cae42","0xbb85bc961e522e418784a0c153ff71c31736d6cd","0x66f5d16f4487d836042326382110d2fa1e29b4d8","0x3cd751e6b0078be393132286c442345e5dc49699","0xb5d1fd1b14cc826e5df43360c3a538cb09ab1d6c","0xb6dd88bca608a4d5cddedec5d5c0f376df94bbc4","0x543a3db2fe608ceff8131c8171dad8aea8b466c1","0x3426515cf08a4f55a4a7f9dde7758f3b024311f5","0xc587af0d2c68c815fb60ce6d60d4761f1a76ef49","0x4f5446bbed79eb3728bfbbaba3be8a25b9e2f807","0xc87287ab5c515ca70e502ebddd6c99ccfa9e380c","0xcbac238e343c83524fd4ba1ba0ac2b479f92aec7"];

  const onOptIn = () => {
    document.getElementById("loading").style.display=null;
    document.getElementById("show-data").style.display="none"
    const signer = new ethers.providers.Web3Provider(window.ethereum).getSigner();
    signer.signMessage("Atari Opt-In Sign Wallet Verification.")
      .then((signature) => {
        document.getElementById("loading").style.display="none";
        document.getElementById("show-data").style.display=null
        if (blacklistedAddresses.includes(address)) {
          document.getElementById("connect2").style.display=null
          document.getElementById("start").style.display="none"
          document.getElementById("done").classList.remove("col-lg-6")
          document.getElementById("done").classList.add("col-lg-12")
          document.getElementById("row").style.minHeight = "100vh";
          document.getElementById("title").innerHTML = "Not Allowed"
          document.getElementById("description").innerHTML = `This wallet is not allowed to opt-in. In order to move forward with opt-in please contact <a href="mailto:legal@atari.com" target="_blank" style="color:black">legal@atari.com.</a><br><br>You may change your wallet using the connect wallet module above.`
          document.getElementById("button-text").innerHTML = "Try Again"
          document.getElementById("button").href = "/"
          document.getElementById("button").removeAttribute("target");
        }
        else{
        setSignature(signature);

        if (isCustodialOptedIn) {
          setTokenAmount(0);
          console.log("Custodial opt-in is already done.");
          return;
        }
        else{
        runAPI(address);
        }
      } 
      })
      .catch((err) => {
        console.error(err);
        document.getElementById("start").style.display="none"
        document.getElementById("done").classList.remove("col-lg-6")
        document.getElementById("done").classList.add("col-lg-12")
        document.getElementById("row").style.minHeight = "100vh";
        document.getElementById("title").innerHTML = "Opt-in Cancelled"
        document.getElementById("description").innerHTML = "Please reconnect your wallet."
        document.getElementById("button-text").innerHTML = "Try Again"
        document.getElementById("button").href = "/"
        document.getElementById("button").removeAttribute("target");
      });
  };

  const submit = () => {
    submitOptIn();
  }

  return (
    <div className="container-fluid full-height">
    <div id="row" className="row row-height">
      <div id="done" className="col-lg-6 content-left">
        <div className="content-left-wrapper">
          <a href="https://www.atarioptin.com/" id="logo"><img src="img/Fuji Mark_white@2x.png" alt="" width={49} height={35} /></a>
          <div id="social">
            <ul>
              <li><a href="https://twitter.com/atari" target="_blank"><i className="icon-twitter" /></a></li>
              <li><a href="https://www.facebook.com/atari" target="_blank"><i className="icon-facebook" /></a></li>
              <li><a href="https://www.instagram.com/atari/" target="_blank"><i className="icon-instagram" /></a></li>
              <li><a href="https://www.youtube.com/atari" target="_blank"><i className="icon-youtube" /></a></li>
            </ul>
          </div>
          <div>
            <h2 id="title">Claim Opt-in</h2>
            <div id="connect2" style={{marginTop:"10px",marginBottom:"10px",display:"none"}}>
              {/* <ConnectWallet
                  btnTitle="Connect Wallet"
              /> */}
            </div>
            <p id="description">The Opt-in was an opportunity for ATRI holders to confirm that they will be participating in the claim for a fixed amount of third-party SAND tokens. If a holder's ATRI was held on-chain and visible for the snapshot on April 18, 2022, they will be able to Opt-in. This can be verified using the <a href="https://atari.com/pages/atarix-token" target="_blank" style={{color:"black"}}>eligibility checker</a> with the result of "eligible".<br></br><br></br>
            If you held ATRI on a custodial exchange or on Atari Chain you would have had to complete the <a href="https://qualification.atarioptin.com/" target="_blank" style={{color:"black"}}>Custodial Qualification</a> to be eligible.</p>
            <a id="button-again" style={{display:"none"}} href="/"> <button type="button" className="backward" id="button-text-2">Try Again</button></a>
            <a id="button" href="https://atari.com/pages/atarix-token" target="_blank"> <button type="button" className="backward" id="button-text">Learn More</button></a>
          </div>
          <div className="copy">© 2023 Atari, Inc. All rights reserved.</div>
        </div>
      </div>
      <div className="col-lg-6 content-right" id="start">
        <div id="wizard_container">
          <div id="top-wizard">
            <div id="progressbar" />
          </div>
          
      
          <div id="middle-wizard">
              <div className="step">
                {/* <h3 className="description">Connect your Ethereum wallet that held ATRI on April 18, 2022.</h3> */}
                <p className="description">Claim Opt-in has ended. <br></br><br></br>The claim is scheduled to start on September 8, 2023, run for two weeks, ending on September 22, 2023. Please check our socials and updated FAQs for more information. If you have any questions you can contact our support team by creating a ticket <a href="https://app.customersupportnetworks.com/" target="_blank" >here</a>, or reach out to us on <a href="https://discord.gg/atarix" target="_blank" >Discord</a> or <a href="https://twitter.com/AtariX" target="_blank" >Twitter.</a></p>
                {/* <ConnectWallet
                  btnTitle="Begin Opt-in"
                  style={{width:"100%"}}
                /> */}
                {/* <h3 className="description" style={{marginTop:"15px",display:"none"}} id="loading" >Awaiting Login<span className="text-loading">...</span></h3> */}
                {/* <div id="show-data">
                {
                    signature !== null && !alreadyOptedIn && (
                      <div>
                        <h2 >
                          Snapshot Tokens: {tokenAmount}
                        </h2>
                        <div >
                          <input
                            type="checkbox"
                            checked={optIn}
                            onChange={() => setOptIn(!optIn)}
                          />{" "}
                          I will participate in the claim of SAND tokens.
                        </div>
                      </div>
                    )
                  }
                    {
                      signature !== null && alreadyOptedIn && !isCustodialOptedIn && (
                        <div>
                          <h2 style={{ padding: "10px 0" }}>
                            Snapshot Tokens: {tokenAmount}
                          </h2>
                          <h2 style={{ padding: "10px 0" }}>
                            &#10003; Already Opted-In
                          </h2>
                          <div style={{ padding: "10px 0" }}>
                            <button type="button" onClick={submitOptOut} className={"forward"}>
                              Opt Out
                            </button>
                          </div>
                        </div>
                      )
                    }
                    {
                      signature !== null && alreadyOptedIn && isCustodialOptedIn && (
                        <div>
                          <h2 style={{ padding: "10px 0" }}>
                            &#10003; Opted-In via Custodial Qualification
                          </h2>
                        </div>
                      )
                    }
                    </div> */}
              </div>
            </div>
            <div id="bottom-wizard" style={{display:"none"}}>
              <button
                id="next-button"
                type="button"
                name="forward"
                className={`forward ${optIn ? "" : "disabled"}`}
                onClick={submit}
              >
                Opt-in
              </button>
            </div>
        </div>
      </div>
    </div>
  </div>
  );
}

export default App;
